import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const { user } = useAuth();

  useEffect(() => {
    // Check if we have access token in URL (from OAuth callback)
    const urlParams = new URLSearchParams(window.location.hash.slice(1));
    const accessToken = urlParams.get('access_token');
    
    if (accessToken) {
      console.log('🔄 OAuth callback detected, access token found');
      console.log('🚀 Redirecting to dashboard...');
      
      // Redirect to dashboard - the auth context will handle the user state
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    } else if (user) {
      // User is already authenticated, redirect to dashboard
      console.log('👤 User already authenticated, redirecting to dashboard');
      window.location.href = '/dashboard';
    }
  }, [user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md">
        <div className="w-16 h-16 mx-auto mb-4">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600"></div>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Completing Sign-In...
        </h2>
        <p className="text-gray-600">
          Please wait while we redirect you to your dashboard.
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;